import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import baseStyles from '../../ElementControlsStyles';
import { isSelectedElementLocked } from 'crazyEditor/redux/modules/element/elementSelectors';
import { clearSelectedElementIds } from 'crazyEditor/redux/modules/stage/stage';
import { hideMobileElement } from 'crazyEditor/redux/modules/element/actions/mobileElementActions';
import { deleteElement, duplicateDesktopElement } from 'crazyEditor/redux/modules/element/actions/desktopElementActions';
import { lockElement, unlockElement } from 'crazyEditor/redux/modules/element/actions/elementPropsActions';
import * as Colors from 'material-ui/styles/colors';
import { CustomSvgIconButton } from 'crazyEditor/components/EditorUI/BaseUI/index';
import { getElementIdForDesktopElementControlView, isMultiSelect } from 'crazyEditor/redux/modules/element/elementSelectors';

@connect(
  (state) => ({
    viewMode: state.editor.viewMode,
    isMobileView: state.editor.isMobileView,
    isSelectedElementLocked: isSelectedElementLocked(state),
    isMultiSelect: isMultiSelect(state),
    selectedElementIds: getElementIdForDesktopElementControlView(state)
  }),
  {
    lockElement,
    unlockElement,
    deleteElement,
    duplicateDesktopElement,
    hideMobileElement,
  }
)
@Radium
export default class EditControl extends Component {

  toggleLock = () => {
    const { selectedElementIds, viewMode, isSelectedElementLocked } = this.props;
    const { lockElement, unlockElement } = this.props;
    if (isSelectedElementLocked) {
      unlockElement(viewMode, selectedElementIds);
    } else {
      lockElement(viewMode, selectedElementIds);
    }
  };

  render() {
    const { selectedElementIds, isSelectedElementLocked, deleteElement, duplicateDesktopElement, hideMobileElement, isMobileView } = this.props;
    return (
      <div style={baseStyles.menuContainer}>
        <div style={baseStyles.menuTitle}>EDIT</div>
        <div style={baseStyles.menuBody}>
          <ul style={baseStyles.menuBodyList}>
            <li style={baseStyles.menuBodyListItem}>
              <CustomSvgIconButton
                iconPath="M12,17A2,2 0 0,0 14,15C14,13.89 13.1,13 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V10C4,8.89 4.9,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z"
                tooltip={`${isSelectedElementLocked ? 'Unlock' : 'Lock'} Element`}
                iconBackground={isSelectedElementLocked ? Colors.yellow700 : undefined}
                iconColor={isSelectedElementLocked ? Colors.grey900 : undefined}
                onClick={this.toggleLock}
              />
            </li>
            {isMobileView &&
            <li style={baseStyles.menuBodyListItem}>
              <CustomSvgIconButton
                iconPath="M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z"
                tooltip="Hide Element"
                onClick={() => { hideMobileElement(selectedElementIds); }}
              />
            </li>
            }
            {!isMobileView &&
            <li style={baseStyles.menuBodyListItem}>
              <CustomSvgIconButton
                iconPath="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"
                tooltip="Duplicate"
                onClick={() => duplicateDesktopElement(selectedElementIds)}
              />
            </li>
            }
            {!isMobileView &&
            <li style={{position: 'absolute', right: '9px', listStyle: 'none'}}>
              <CustomSvgIconButton
                iconPath="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"
                tooltip="Delete Element"
                onClick={() => deleteElement(selectedElementIds)}
                tooltipPosition="bottom-left"
              />
            </li>
            }
          </ul>
        </div>
      </div>
    );
  }
}